import { api } from '@/lib/api/client'
import type { AskAnswer, Brief } from '@/types/intelligence'

export async function fetchBrief(date?: string): Promise<Brief> {
  const { data } = await api.get<{ data: Brief }>(date === undefined ? '/brief' : `/brief/${date}`)

  return data.data
}

/** Generate today's brief now, rather than waiting for the 05:30 schedule. */
export async function generateBrief(): Promise<Brief> {
  const { data } = await api.post<{ data: Brief }>('/brief')

  return data.data
}

export async function ask(question: string): Promise<AskAnswer> {
  const { data } = await api.post<{ data: AskAnswer }>('/ask', { question })

  return data.data
}
